import request from '@/utils/request'
// manager get producer list
export const producerList = (data) => {
  return request({
    url: '/api/fmanager/producerList',
    method: 'get',
    params: data
  })
}

export const producerUpdateStatus = (data) => {
  return request({
    url: '/api/fmanager/updateStatus',
    method: 'post',
    data: data
  })
}

// manager get producer detail
export const producerDetail = (data) => {
  return request({
    url: '/manager/producerDetail',
    method: 'get',
    params: data
  })
}
// manager approval producer info or well
export const approvalProducerInfo = (data) => {
  return request({
    url: '/api/fmanager/updateStatus',
    method: 'post',
    data: data
  })
}
export const approvalWellList = (data) => {
  return request({
    url: '/api/fmanager/wellList',
    method: 'get',
    params: data
  })
}
export const annualReviewList = (data) => {
  return request({
    url: '/api/fmanager/producerList',
    method: 'get',
    params: {status: 5, ...data}
  })
}
export const producerListForMessage = (data) => {
  return request({
    url: '/api/fmanager/producerListForMessage',
    method: 'get',
    params: data
  })
}
export const updateWellStatus = (data) => {
  return request({
    url: '/api/fmanager/updateWellStatus',
    method: 'post',
    data: data
  })
}
